import { copyRacersService } from '../services';

export const onDeleteTask = async (taskId: number) => {
  await copyRacersService.deleteTask(taskId);
};
